import type { WebinarRoomRecordingViewDto } from '@/api/webinarRoom'
import { CLOUD_PROVIDER_LABEL, type CloudProvider } from '@/components/common/upload/cloudFile'
import { formatBytes } from '@/utils/fileSize'

/** The words around a video upload, shared by the Room tab's Recording and While viewers wait cards. */

/** A computer upload this browser is not running: another tab's, or one whose tab was closed and stopped. */
export const STALLED_NOTE = 'If that tab was closed, the upload stopped: cancel it and upload the file again.'

/** The line under an upload this browser is not running. A cloud import runs on the server and reports no progress. */
export function waitingText(video: WebinarRoomRecordingViewDto | null, source: CloudProvider | null): string {
    if (!source) return 'Uploading from the browser tab that started it.'
    return video?.SizeBytes != null ? `${formatBytes(video.SizeBytes)} from ${CLOUD_PROVIDER_LABEL[source]}` : `From ${CLOUD_PROVIDER_LABEL[source]}`
}
